import React, { useState, useEffect } from "react";
import { Box, createTheme, Stack, ThemeProvider } from "@mui/material";

import { useParams } from "react-router-dom";
import { Avatar } from "@mui/material";
import ViewQuiltIcon from "@mui/icons-material/ViewQuilt";
import ToggleButton from "@mui/material/ToggleButton";
import { Feedback } from "../newsfeed/Feedback";
import { Answers } from "../newsfeed/Answers";
import { AskQ } from "../askquestion/AskQ";
import { Settings } from "../menunav_compo/Settings";
import { Profile } from "../menunav_compo/Profile";
import { Hostels } from "../hostel/Hostels";
import { Posthostel } from "../hostel/Posthostel";
import Project from "../projects/Project";
import { Postproject } from "../projects/Postproject";
import { Projects } from "../projects/Projects";
import { Scholarship } from "../scholarships/Scholarship";
import { PostScholarships } from "../scholarships/PostScholarships";
import { Internship } from "../internships/Internship";
import { Postinternship } from "../internships/Postinternship";
import { Fyps } from "../fyp/Fyps";
import { Addnewidea } from "../fyp/Addnewidea";
import { Addalready } from "../fyp/Addalready";
import { Seealready } from "../fyp/Seealready";
import { Listnew } from "../fyp/Listnew";
import { Usernewsfeed } from "../newsfeed/usernewsfeed";
import { Userhostels } from "../hostel/userhostel";
import { Userscholarship } from "../scholarships/userscholarships";
import { Userinternship } from "../internships/Userinternship";
import UserProject from "../projects/UserProject";
import { Userprojects } from "../projects/userprojects";
import { Search } from "../menunav_compo/Search";
import HostelDetails from "../hostel/HostelDetails";
import InternshipDetails from "../internships/InternshipDetails";
import ScholarshipDetails from "../scholarships/ScholarshipDetails";
import ProjectDetails from "../projects/ProjectDetails";
import CompletedFypDetail from "../fyp/CompletedFypDetail";

const MainContentContainer = ({
  mode,
  showSidebar,
  setShowSidebar,
  type,
  searchedText,
  setShowInterestCollectionGrid,
}) => {
  // const [showSidebar, setShowSidebar] = useState(true);
  const [menu, setMenu] = useState("home");
  const params = useParams();
  // useEffect(() => {
  //   if (params?.symbol?.length > 0) {
  //     setMenu("DetailsPage");
  //   } else {
  //     setMenu("stocks");
  //   }
  // }, [params]);

  useEffect(() => {
    setMenu(type);
  }, [type]);
  return (
    <Box
      sx={{
        backgroundColor: "colorWhiteSmoke.main",
        overflowY: "scroll",
        height: "90vh",
        // borderLeft: "1px solid rgb(230, 235, 241)",
      }}
      className="main__container pl-8 pr-8"
    >
      {/* <Box
        sx={{
          backgroundColor: "bgPrimary.main",
          padding: " 10px 20px 10px 20px",
          display: "flex",
          justifyContent: "space-between",
          display: { xs: "flex", md: "none" },
          zIndex: "10000",
        }}
      >
      
        <ToggleButton
          value="quilt"
          aria-label="quilt"
          onClick={() => setShowSidebar(!showSidebar)}
          sx={{ border: "none" }}
        >
          <ViewQuiltIcon />
        </ToggleButton>
      
      </Box> */}
      {/* <h1>Main Content</h1> */}

      {menu == "home" || menu == "admin-dashboard" ? (
        <>
          {/* <StocksPage mode={mode} /> */}
          <Feedback />
        </>
      ) : menu == "answers" ? (
        <>
          <Answers />
        </>
      ) : menu == "ask-question" ? (
        <>
          <AskQ />
        </>
      ) : menu == "all-answers" ? (
        <>
          <Answers />
        </>
      ) : menu == "settings" ? (
        <>
          <Settings />
        </>
      ) : menu == "profile" ? (
        <>
          <Profile
            setShowInterestCollectionGrid={setShowInterestCollectionGrid}
          />
        </>
      ) : menu == "user-profile" ? (
        <>
          <Profile />
        </>
      ) : menu == "hostels" ? (
        <>
          <Hostels />
        </>
      ) : menu == "hostel-details" ? (
        <>
          <HostelDetails />
        </>
      ) : menu == "upload-hostel-data" ? (
        <>
          <Posthostel />
        </>
      ) : menu == "projects" ? (
        <>
          <Projects />
        </>
      ) : menu == "project-details" ? (
        <>
          <ProjectDetails />
        </>
      ) : menu == "post-project" ? (
        <>
          <Postproject />
        </>
      ) : menu == "scholarships" ? (
        <>
          <Scholarship />
        </>
      ) : menu == "scholarship-details" ? (
        <>
          <ScholarshipDetails />
        </>
      ) : menu == "post-scholarship" ? (
        <>
          <PostScholarships />
        </>
      ) : menu == "internships" ? (
        <>
          <Internship />
        </>
      ) : menu == "internship-details" ? (
        <>
          <InternshipDetails />
        </>
      ) : menu == "post-internship" ? (
        <>
          <Postinternship />
        </>
      ) : menu == "fyp" ? (
        <>
          <Fyps />
        </>
      ) : menu == "add-new-fyp" ? (
        <>
          <Addnewidea />
        </>
      ) : menu == "add-already-created-fyp" ? (
        <>
          <Addalready />
        </>
      ) : menu == "see-already-created-fyp" ? (
        <>
          <Seealready />
        </>
      ) : menu == "list-new-fyp-ideas" ? (
        <>
          <Listnew />
        </>
      ) : menu == "completed-fyp-detail" ? (
        <>
          <CompletedFypDetail />
        </>
      ) : menu == "my-questions" ? (
        <>
          <Usernewsfeed />
        </>
      ) : menu == "edit-question" ? (
        <>
          <AskQ />
        </>
      ) : menu == "edit-hostel" ? (
        <>
          <Posthostel />
        </>
      ) : menu == "my-hostels" ? (
        <>
          <Userhostels />
        </>
      ) : menu == "my-scholarships" ? (
        <>
          <Userscholarship />
        </>
      ) : menu == "edit-scholarship" ? (
        <>
          <PostScholarships />
        </>
      ) : menu == "edit-internship" ? (
        <>
          <Postinternship />
        </>
      ) : menu == "my-internships" ? (
        <>
          <Userinternship />
        </>
      ) : menu == "my-projects" ? (
        <>
          <Userprojects />
        </>
      ) : menu == "edit-project" ? (
        <>
          <Postproject />
        </>
      ) : menu == "search" ? (
        <>
          <Search searchedText={searchedText} />
        </>
      ) : (
        <></>
      )}
      {/* : menu == "earningsPage" ? (
        <>
          <EarningsPage />
        </>
      ) : menu == "pressReleases" ? (
        <>
          <PressReleases />
        </>
      ) : menu == "account" ? (
        <>
          <Account />
        </>
      ) : menu == "accountInfo" ? (
        <>
          <AccountInfo />
        </>
      ) : menu == "subscribe" ? (
        <>
          <SubscribeForm />
        </>
      ) : (
        <></>
      )} */}
    </Box>
  );
};

export default MainContentContainer;
